import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import Banner from '../components/banner'

const News = ({ data }) => {
  return (
    <Layout
      title="News"
      description="News"
      lang="ja"
    >
      <Banner message="News"></Banner>
      <div className='container section'>
        {
          data.allMarkdownRemark.edges.map(({ node }, idx) => {
            return (
              <div className="news" dangerouslySetInnerHTML={{ __html: node.html }} key={idx} />
            )
          })
        }
      </div>
    </Layout>
  )
}

export default News

export const query = graphql`
query NewsQuery {
  allMarkdownRemark(
    filter: {frontmatter: {
      type: {eq: "news"}
    }}
    ) {
    edges {
      node {
        html
      }
    }
  }
}
`